import { createSlice } from '@reduxjs/toolkit';
import { editLotteryInfo, getLotteries, viewLotteries } from './lotteryService';

const initialState = {
    lotteryTickets: {
        isLotteriesLoading: null,
        isLotteriesSuccess: null,
        pageCount: 0,
        lotteries: [],
        lotteriesCount: 0,
    },
    updateLotteryDetails: {
        isUpdatingDetails: null,
        isUpdatingDetailsSuccess: null,
        updateMsg: null,
    },
    viewTickets: {
        isViewLoading: null,
        isViewSuccess: null,
        pageCount: 0,
        ticketList: [],
    },
};

const lotterySlice = createSlice({
    name: 'lotteryTicket',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getLotteries.pending, (state) => {
            state.lotteryTickets = {
                ...initialState.lotteryTickets,
                isLotteriesLoading: true,
            };
        });

        builder.addCase(getLotteries.rejected, (state) => {
            state.lotteryTickets = {
                ...initialState.lotteryTickets,
                isLotteriesLoading: false,
                isLotteriesSuccess: false,
            };
        });

        builder.addCase(getLotteries.fulfilled, (state, action) => {
            state.lotteryTickets = {
                ...initialState.lotteryTickets,
                isLotteriesLoading: false,
                isLotteriesSuccess: true,
                pageCount: action.payload.pageCount || 0,
                lotteries: action.payload.data || [],
                lotteriesCount: action.payload.count || 0,
            };
        });

        //Update details
        builder.addCase(editLotteryInfo.pending, (state) => {
            state.updateLotteryDetails = {
                ...initialState.updateLotteryDetails,
                isUpdatingDetails: true,
                updateMsg: 'Updating...',
            };
        });

        builder.addCase(editLotteryInfo.rejected, (state, action) => {
            state.updateLotteryDetails = {
                ...initialState.updateLotteryDetails,
                isUpdatingDetails: false,
                isUpdatingDetailsSuccess: false,
                updateMsg: action.payload.message,
            };
        });

        builder.addCase(editLotteryInfo.fulfilled, (state, action) => {
            state.updateLotteryDetails = {
                ...initialState.updateLotteryDetails,
                isUpdatingDetails: false,
                isUpdatingDetailsSuccess: true,
                updateMsg: action.payload.message,
            };
        });

        // View tickets
        builder.addCase(viewLotteries.pending, (state) => {
            state.viewTickets = {
                ...initialState.viewTickets,
                isViewLoading: true,
            };
        });

        builder.addCase(viewLotteries.rejected, (state) => {
            state.viewTickets = {
                ...initialState.viewTickets,
                isViewLoading: false,
                isViewSuccess: false,
            };
        });

        builder.addCase(viewLotteries.fulfilled, (state, action) => {
            state.viewTickets = {
                ...initialState.viewTickets,
                isViewLoading: false,
                isViewSuccess: true,
                pageCount: action.payload.pageCount || 0,
                ticketList: action.payload.data || [],
            };
        });
    }, 
});

export default lotterySlice.reducer;
